import styled from 'styled-components';
import { caption, colors, fontWeights, shadows, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const TinyTile = styled.div<{ isDisabled: boolean }>`
  ${caption}
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  border-radius: ${spacing.half};
  padding: ${spacing.half};
  box-shadow: ${shadows.subtle};
  border: 1px solid ${colors.green100};
  width: fit-content;
  margin-top: ${spacing.half};

  span {
    display: block;
    font-weight: ${fontWeights.bold};
  }

  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${colors.textDisabled};
    border: 1px solid ${colors.grey15};
  `};
`;

export const IconContainer = styled.div<{ isDisabled: boolean }>`
  align-items: center;
  border-radius: ${pxToRem(6)};
  display: flex;
  flex-shrink: 0;
  height: ${pxToRem(24)};
  justify-content: center;
  width: ${pxToRem(24)};
  background: ${({ isDisabled }) => (isDisabled ? colors.textDisabled : colors.forest100)};
`;

export const RadioListWrapper = styled.div`
  margin-bottom: ${spacing.base};
`;
